// src/pages/projects/shooter.tsx
"use client";

import React from "react";
import { UnityPlayer } from "@/components/UnityPlayer";

/**
 * Build assets are served straight from Cloudflare R2 — no Vercel function in
 * the request path. R2 charges nothing for egress, so players can reload as
 * often as they like without consuming a metered allowance.
 *
 * Content-Encoding and Content-Type are stored as object metadata at upload
 * time (see scripts/upload-shooter-r2.mjs); nothing rewrites headers at request
 * time any more.
 *
 * Swap this for https://cdn.puzzlebros.studio once the domain is on Cloudflare
 * DNS — the r2.dev URL is rate-limited and not intended for production.
 */
const SHOOTER_BUILD_URL =
  "https://pub-7ef89e97532e43368fd0f7deeb49dac1.r2.dev/games/shooter";

export default function ShooterPage() {
  return (
    <UnityPlayer
      buildPath={SHOOTER_BUILD_URL}
      buildName="Shooter"
      projectName="OÍD MORTALES"
      loadingLogoSrc="/images/loading-logo.png"
      compression="br"
    />
  );
}
